export const GRAPHQL_API_URL = '/api/graphql/v2';
